<br />
  <div class="row">
    <!-- [ GRAFICO COM OS PROBLEMAS DE ORIGEM ] -->
    <div class="col-5">
      <div class="titleDash">
        <h4>{{ titleCharOriginProblem }}</h4>
      </div>
      <app-dashboard-pizza-workaround></app-dashboard-pizza-workaround>
    </div>
    <!-- [ GRAFICO COM OS PROBLEMAS ENCONTRADOS ] -->
    <div class="col-7">
      <div class="titleDash">
        <h4>{{ titleCharProblem }}</h4>
      </div>
      <app-dashboard-column-workaround></app-dashboard-column-workaround>
    </div>
  </div>
  <br />
 <!-- [ TABELA COM OS PROBLEMAS ] -->
 <div class="mat-app-background basic-container">
    <app-data-workaround-list></app-data-workaround-list>
</div>
